import BaseView from "scripts/views/baseView";
import MediaListView from "scripts/views/mediaListView";
import templateModulesPageListSubPage from "templates/modulesPageListSubPage.hbs";

class ModulesPageListSubPageView extends BaseView {
  get template() {
    return templateModulesPageListSubPage;
  }

  constructor(options) {
    super(options);

    this.mediaListView = this.addSubView(
      new MediaListView({
        collection: this.collection,
      }),
    );
  }

  render() {
    this.$el.html(
      this.template({
        moduleCount: this.collection.length,
      }),
    );

    this.mediaListView
      .appendTo($("#bb-modules-page-list-sub-page-list-view-region"))
      .render();

    return this;
  }

  sync() {
    return this.mediaListView.fetch();
  }
}

export default ModulesPageListSubPageView;
